import React, { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import logo from '../assets/logo-main.png';
import Seo from '../components/Seo';
import { useAuth } from '../context/AuthContext';
import { apiBaseUrl } from '../config';
import axios from 'axios';
import './Auth.css';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      // Fetch user data with token
      axios.get(`${apiBaseUrl}/user/me`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        withCredentials: true
      })
      .then(response => {
        if (response.data.success) {
          return login(token).then(() => navigate('/dashboard'));
        } else {
          navigate('/signin?error=oauth_failed');
        }
      })
      .catch(error => {
        console.error('OAuth callback error:', error);
        navigate('/signin?error=oauth_failed');
      });
    } else {
      navigate('/signin?error=oauth_failed');
    }
  }, [searchParams, navigate, login]);

  return (
    <div className="auth-page">
      <Seo title="Signing in — InvFly" description="Completing sign-in." noIndex />
      <header className="auth-page-header">
        <div className="auth-header-inner">
          <Link to="/" className="auth-header-logo">
            <img src={logo} alt="InvFly" />
          </Link>
        </div>
      </header>
      <div className="auth-page-body">
        <div className="auth-container">
          <div className="auth-card">
            <div className="loading-container">
              <div className="loading-spinner" aria-hidden />
              <p>Completing authentication…</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
